import { buildLocalizedPath } from "./routes";

export const DEFAULT_SITE_URL = "https://coldexperience.se";

export const resolveSiteUrl = (value) =>
  value || process.env.REACT_APP_SITE_URL || DEFAULT_SITE_URL;

export const buildAbsoluteUrl = (base, path) => {
  const normalizedBase = (base || "").replace(/\/+$/, "") || DEFAULT_SITE_URL;

  if (!path) {
    return normalizedBase;
  }

  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  return `${normalizedBase}${normalizedPath}`;
};

export const derivePageMeta = ({
  t,
  i18n,
  pageKey,
  routeKey,
  defaults = {},
}) => {
  const translation =
    t?.(`seo.${pageKey}`, { returnObjects: true, defaultValue: {} }) || {};

  const siteUrl = resolveSiteUrl(translation.siteUrl);
  const canonicalPath =
    translation.canonicalPath ||
    buildLocalizedPath(i18n.language, routeKey || pageKey || "/");

  const canonicalUrl = buildAbsoluteUrl(siteUrl, canonicalPath);

  const title = translation.title || defaults.title || "";
  const description = translation.description || defaults.description || "";
  const keywords = translation.keywords || defaults.keywords || "";

  const ogTitle = translation.ogTitle || title;
  const ogDescription = translation.ogDescription || description;
  const ogImage = translation.ogImage || defaults.ogImage || "/og/default.jpg";
  const twitterImage =
    translation.twitterImage || translation.ogImage || defaults.twitterImage || ogImage;

  const jsonLd = translation.jsonLd || defaults.jsonLd || null;

  return {
    siteUrl,
    canonicalPath,
    canonicalUrl,
    title,
    description,
    keywords,
    ogTitle,
    ogDescription,
    ogImage,
    twitterImage,
    jsonLd,
  };
};
